import Split from "react-split";
import { ReactNode } from "react";
import { ScrollArea } from "./ScrollArea";
import { Box } from "@radix-ui/themes";
import { createHandleElement } from "./ResizeHandle";

interface SplitViewProps {
  children: ReactNode;
  sizes?: [number, number];
  minSize?: [number, number];
}

interface PanelProps {
  children: ReactNode;
}

const Left = ({ children }: PanelProps) => {
  return (
    <Box style={{ height: "100%", width: "100%" }}>
      <ScrollArea style={{ height: "100%", width: "100%", overflow: "auto" }}>
        {children}
      </ScrollArea>
    </Box>
  );
};

const Right = ({ children }: PanelProps) => {
  return (
    <Box style={{ height: "100%", width: "100%" }}>
      <ScrollArea style={{ height: "100%", width: "100%", overflow: "auto" }}>
        {children}
      </ScrollArea>
    </Box>
  );
};

const SplitView = ({ children, sizes = [30, 70], minSize = [225, 500] }: SplitViewProps) => {
  return (
    <Box style={{ height: "100%" }}>
      <Split
        sizes={sizes}
        minSize={minSize}
        style={{
          display: "flex",
          height: "100%",
          userSelect: "none",
        }}
        gutter={() => {
          const gutterElement = document.createElement("div");
          gutterElement.style.cssText = `
            position: relative;
            cursor: col-resize;
            user-select: none;
          `;

          const edge = document.createElement("div");
          edge.style.cssText = `
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 4px;
            height: 100%;
            background-color: var(--gray-4);
            transition: background-color 0.2s ease;
          `;
          
          gutterElement.addEventListener("mouseenter", () => {
            edge.style.backgroundColor = "var(--gray-6)";
          });
          
          gutterElement.addEventListener("mouseleave", () => {
            edge.style.backgroundColor = "var(--gray-4)";
          });

          const handle = createHandleElement();
          handle.style.cssText += `
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 12px;
          `;


          gutterElement.appendChild(edge);
          gutterElement.appendChild(handle);
          return gutterElement;
        }}
      >
        {children}
      </Split>
    </Box>
  );
};

SplitView.Left = Left;
SplitView.Right = Right;

export default SplitView;
